import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme } from '@material-ui/core/styles';
import {HashRouter as Router, Switch, Route} from "react-router-dom";

// Components
import Start from '../components/Start/Start';
import Header from '../components/Header/Header';
import Game from '../components/Game/Game';

// Material UI Components
import { ThemeProvider, Container, Fade } from '@material-ui/core';

// Material UI Custom Theme
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#85C1E9',
      main: '#3498DB',
      dark: '#2874A6',
    },
    secondary: {
      light: '#F7DC6F',
      main: '#F1C40F',
      dark: '#B7950B',
    },
    success: {
      light: '#82E0AA',
      main: '#2ECC71',
      dark: '#239B56',
    },
    error: {
      light: '#F1948A',
      main: '#E74C3C',
      dark: '#B03A2E',
    },
  },
});

export default class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      cardType: null,
      gameState: '',
      soundState: true,
      volume: null,
      prevVolume: null,
      gameTime: null,
      leaderboard: [],
    }
  }

  static propTypes = {
    cardType: PropTypes.object,
    gameState: PropTypes.string,
    soundState: PropTypes.bool,
    volume: PropTypes.number,
    prevVolume: PropTypes.number,
    gameTime: PropTypes.number,
    leaderboard: PropTypes.array,
  }

  componentWillMount(){
    // Will set a variables with the value of the local storage 
    const setLeaderboard = JSON.parse(localStorage.getItem("Leaderboard") || "[]");
    const setSoundState = JSON.parse(localStorage.getItem("SoundState") || "true");
    const setVolume = JSON.parse(localStorage.getItem("Volume") || "0.2");
    const setPrevVolume = JSON.parse(localStorage.getItem("PrevVolume") || "0.2");
    const setCardType = JSON.parse(localStorage.getItem("CardType") || "null");

    this.setState({
      cardType: setCardType,
      soundState: setSoundState,
      volume: parseFloat(setVolume),
      prevVolume: parseFloat(setPrevVolume),
      leaderboard: setLeaderboard,
    })
  }

  // This method will store the current phase of the application in the gameState state
  handleGameState = (phase) => {
    this.setState({
      gameState: phase
    })
  }

  // This method will store the icon array in the cardType state
  handleClickSelectCard = (card) => {
    // Setting the cardType array into our local storage
    localStorage.setItem("CardType", JSON.stringify(card));

    this.setState({
      cardType: card
    })
  }

  // This method will store the seconds in the gameTime state
  handleGetSeconds = (time) => {
    this.setState({
      gameTime: time
    })
  }

  // This method will toggle the audio 
  handleClickToggleSound = (state) => {
    if(state === "On"){
      this.setState(state => ({
        soundState: true,
        volume: state.prevVolume
      }));
    }else{
      this.setState(state => ({
        soundState: false,
        prevVolume: state.volume,
        volume: 0,
      }));
    }

    // Setting the state into our local storage
    localStorage.setItem("SoundState", JSON.stringify(!this.state.soundState));
    localStorage.setItem("Volume", JSON.stringify(this.state.volume));
    localStorage.setItem("PrevVolume", JSON.stringify(this.state.prevVolume));
  }

  // This method will set the volume level for the audio
  HandleSliderChange = (num) => {
    this.setState({
      volume: parseFloat(num / 100)
    });

    // Setting the SoundState into our local storage
    localStorage.setItem("Volume", JSON.stringify(num / 100));
  }

  /* 
    This method will create an object that holds the name of the player and the number of seconds it took the player to match all cards
    Then it will store the object in the leaderboard array
  */ 
  handleClickEnterName = (name) => {
    if(name === ""){
      return
    }else{
      const time = this.state.gameTime;
      const newLeaderboard = [...this.state.leaderboard];

      const newItem = {
        id: Math.random(),
        name: name,
        time: time
      };

      newLeaderboard.push(newItem);

      newLeaderboard.sort((a, b) => parseFloat(a.time) - parseFloat(b.time));

      // Setting the leaderboard array into our local storage
      localStorage.setItem("Leaderboard", JSON.stringify(newLeaderboard));

      this.setState({
        gameState: '',
        gameTime: null,
        leaderboard: newLeaderboard,
      })
    }
  }

  // This method will clear the leaderboard
  handleClickClearLeaderboard = () => {
    // Deleting the Leaderboard item and CardType from local storage
    localStorage.removeItem("Leaderboard")
    localStorage.removeItem("CardType")

    this.setState({
      leaderboard: []
    })
  }

  render(){
    return (
      <React.Fragment>
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <Router>
            <Switch>
              <Route path="/game">
                <Container maxWidth="md" disableGutters>
                  <Fade in timeout={2000}>
                    <div>
                      <Header 
                        cardType={this.state.cardType} 
                        gameState={this.state.gameState} 
                        soundState={this.state.soundState} 
                        volume={this.state.volume}
                        prevVolume={this.state.prevVolume}
                        leaderboard={this.state.leaderboard} 
                        handleGetSeconds={this.handleGetSeconds} 
                        onClickToggleSound={this.handleClickToggleSound} 
                        onChangeHandleSliderChange={this.HandleSliderChange} 
                        onClickSelectCard={this.handleClickSelectCard} 
                        onClickClearLeaderboard={this.handleClickClearLeaderboard} />
                      <Game 
                        cardType={this.state.cardType} 
                        gameState={this.state.gameState} 
                        volume={this.state.volume}
                        handleGameState={this.handleGameState} 
                        onClickEnterName={this.handleClickEnterName} />
                    </div>
                  </Fade>
                </Container>
              </Route>
              <Route exact path="/">
                <Start volume={this.state.volume} />
              </Route>
            </Switch>
          </Router>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}